import PropTypes from 'prop-types';
import ImageProp from '../../propTypes/imageProp';

const propType = {
  countryCode: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired,
  taxCode: PropTypes.string.isRequired,
  taxType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  continent: PropTypes.string.isRequired,
  flagEmoji: PropTypes.string.isRequired,
  flag: PropTypes.shape(ImageProp.propType),
};

export default { propType };
